// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","title":"Header_title__XruNr","logo":"Header_logo__G+ea6"};